import $ from "jquery";

import {reInitScripts} from "../../utils/re-init-scripts";
import cookieData from '../cookie-data';
import {paginate} from "../../utils/pagination";

const $document = $(document);
const $body = $('body');
let pageSize = cookieData.receive('notificationsSize') || 12;
let elementsOnPage = pageSize;
let currentPage = 1;
let totalRecords = 0;
let index = 0;
let categoryId = 0;
let searchText = null;
let selectedNotifications = [];
let notificationToRemove = null;
let notificationsIsLoaded = false;
let rubricsIsLoaded = false;

function init(elements) {
    const $wrap = $(elements);
    const $notifications = $wrap.find('[data-notifications-list]');
    const $filterBlocks = $('[data-filter-block]');
    const $filterItem = $('[data-notifications-filter]');
    const $checkAll = $('[data-notifications-checkbox="all"]');
    const $checkmark = $checkAll.closest('.checkbox').find('.checkbox__checkmark');
    const $readNotifications = $('[data-notifications-read]');
    const type = $wrap.data('type');
    const $rubrics = $wrap.find('[data-rubrics-list]');
    const $pageSizer = $wrap.find('[data-page-sizer]');
    const $form = $('[data-search-notifications]');
    const $input = $form.find('input');
    const $submitButton = $form.find('button[type="submit"]');
    const $settingsTable = $('[data-settings-popup]');
    const $settingsList = $settingsTable.find('[data-settings-list]');

    getNotifications();
    getRubrics();
    getNotificationSettings();

    $document.on('click', '[data-rubrics-item]', function () {
        const $this = $(this);
        const $others = $('[data-rubrics-item]');

        if ($this.hasClass('is-active')) {
            return false;
        }

        $this.addClass('is-active');
        $others.not($this).removeClass('is-active');
        categoryId = $this.data('rubrics-id');
        currentPage = 1;
        getNotifications();
    });

    $document.on('click', '[data-page]', function () {
        const $this = $(this);
        const page = $this.data('page');

        if ($this.hasClass('disabled')) {
            return false;
        }

        if (page === 'prev') {
            currentPage -= 1;
        } else if (page === 'next') {
            currentPage += 1;
        } else {
            currentPage = page;
        }

        categoryId = $wrap.find('[data-rubrics-item].is-active').data('rubrics-id') || 0;
        getNotifications();
    });

    $document.on('change', '[data-notifications-checkbox]', function (e) {
        const $this = $(e.target);
        const type = $this.data('notifications-checkbox');
        const status = $this.is(':checked');

        if (type === 'all') {
            if ($checkmark.hasClass('is-partial')) {
                clearSelectedNotifications();
            } else {
                const $checkboxes = $('[data-notifications-checkbox]').not($this);
                checkNotifications($checkboxes, status);
            }
        } else {
            const id = $this.closest('.notifications-item').data('notification-id');

            if (status) {
                selectedNotifications.push({id});
            } else {
                selectedNotifications = selectedNotifications.filter((item) => item.id !== id);
            }
        }

        toggleFilterBlocks();
        toggleCheckAll();
        toggleCheckmark();
    });

    $document.on('click', '[data-notifications-remove]', function () {
        const $this = $(this);
        const id = $this.data('notifications-remove');
        if (id) {
            notificationToRemove = id;
        }
    });

    $document.on('click', '[data-notifications-ok]', function () {
        window.magnificPopup.close();
        removeNotifications();
    });

    $document.on('change', '[data-settings-check]', function () {
        const $this = $(this);
        const $parent = $this.closest('[data-settings-item]');
        const currentStatus = $this.is(':checked');
        const initialStatus = $this.data('initial-status');
        const data = $parent.data('settings-item');
        const type = $this.data('type');

        if (currentStatus !== initialStatus) {
            $this.attr('data-is-changed', true);
        } else {
            $this.removeAttr('data-is-changed');
        }

        data[type] = currentStatus;
        $parent.attr('data-settings-item', JSON.stringify(data));
        toggleSettingsConfirm();
    });

    $document.on('click', '[data-settings-confirm]', function () {
        const $items = $('[data-settings-item]');
        const data = [];

        $.each($items, function (i, item) {
            const $item = $(item);
            if ($item.find('input[data-is-changed]').length) {
                data.push($(item).data('settings-item'));
            }
        });

        if (data.length) {
            setNotificationSettings(data);
        }
    });

    let timeoutId = null;
    $input.on('input', function (event) {
        clearTimeout(timeoutId);
        const $this = $(event.target);
        timeoutId = setTimeout(() => {
            searchText = $this.val().trim() || null;
            if (searchText) {
                $submitButton.removeAttr('disabled');
            } else {
                $submitButton.attr('disabled', true);
                if ($form.hasClass('is-completed')) {
                    getNotifications();
                    $form.removeClass('is-completed');
                }
            }
        }, 300);
    });

    $form.on('submit', function (event) {
        event.preventDefault();
        const value = $input.val().trim();

        if (!value) {
            return false;
        }

        $form.addClass('is-completed');
        getNotifications(value);
        getRubrics();
    });

    $pageSizer.on('change.select2', function (e) {
        const $this = $(e.target);
        const oldPageSize = pageSize;
        pageSize = parseInt($this.val());
        currentPage = Math.ceil((oldPageSize * (currentPage - 1) + 1) / pageSize);
        getNotifications();
        cookieData.add('notificationsSize', $this.val(), {expires: 3600 * 24 * 180, path: '/'});
    });

    $filterItem.on('click', function () {
        const $this = $(this);
        const type = +$this.data('notifications-filter');
        let $elems;

        if (type === 0) {
            $elems = $('[data-notification-status="0"] [data-notifications-checkbox]');
        } else if (type === 1) {
            $elems = $('[data-notification-status="1"] [data-notifications-checkbox]');
        } else {
            $elems = $('[data-notification-status] [data-notifications-checkbox]');
        }

        clearSelectedNotifications();
        checkNotifications($elems);
        toggleFilterBlocks();
        toggleCheckAll();
        toggleCheckmark();
    });

    $readNotifications.on('click', readNotifications);

    function getNotifications() {
        $body.addClass('is-loading');
        $checkAll.prop('checked', false);
        selectedNotifications = [];
        toggleFilterBlocks();
        toggleCheckmark();

        $.ajax({
            url: '/' + window.currentLang + '/UserMessages/GetUserMailBoxList',
            type: 'post',
            data: {
                page: currentPage,
                rowOnPage: pageSize,
                caregoryId: categoryId,
                type: type,
                searchText: searchText
            },
            success: (response) => {
                totalRecords = response.totalRows;
                elementsOnPage = response.messages.length;
                if (!notificationsIsLoaded) notificationsIsLoaded = true;
                const notificationsGroups = {};
                response.messages.forEach(item => {
                    const date = item.PublishDateStr.split(' ')[0];
                    notificationsGroups[date] ? notificationsGroups[date].push(item) : notificationsGroups[date] = [item];
                });

                let result = "";
                if (totalRecords > 0) {
                    for (let [key, value] of Object.entries(notificationsGroups)) {
                        let root = `
                        <div class="notifications-block">
                            <div class="notifications-block__date">${key}</div>
                    `;
                        value.forEach((elem) => {
                            const item = `
                            <div class="notifications-item _my-md js-import" data-notification-status="${elem.MessageStatus}" 
                                 data-notification-id="${elem.Id}">
                                <div class="checkbox _mr-md _mt-xxs">
                                    <input type="checkbox" class="checkbox__control" name="notifications[]" 
                                           id="notificationItem-${index}" data-notifications-checkbox>
                                    <label class="checkbox__label" for="notificationItem-${index}">
                                        <span class="checkbox__checkmark">
                                            <svg><use xlink:href="#checkmark"></use></svg>
                                        </span>
                                    </label>
                                </div>
                                <div class="notifications-item__content">
                                    <div class="notifications-item__title _mb-xxs">${elem.Title}</div>
                                    <div class="notifications-item__text">${elem.Content}</div>
                                </div>
                                <div class="_flex _flex-column _justify-between _items-center _pl-md">
                                    <div class="notifications-item__icon js-import" data-notifications-remove="${elem.Id}"
                                         data-mfp="inline" data-mfp-src="#delete-notifications">
                                        <svg><use xlink:href="#delete"></use></svg>
                                    </div>
                                </div>
                            </div>
                        `;
                            root += item;
                            index += 1;
                        });
                        root += "</div>";
                        result += root;
                    }
                } else {
                    result = `
                        <div class="notifications-block__empty">${window.translates.notifications.empty}</div>
                    `;
                }

                $notifications.html(result);
                if ($notifications.length > 0) {
                    currentPage = paginate(totalRecords, pageSize, currentPage);
                    reInitScripts($notifications.get(0));
                }
                if (rubricsIsLoaded) {
                    $body.removeClass('is-loading');
                }
            }
        });
    }

    function getRubrics() {
        $.ajax({
            url: '/' + window.currentLang + '/UserMessages/GetNotificationCategoryList',
            type: 'post',
            data: {
                CountryItemId: type
            },
            success: (response) => {
                rubricsIsLoaded = true;
                let result = "";
                let count = 0;
                let number = type === 2 ? 1 : 0;
                response.forEach((item, i) => {
                    let element = `
                        <div class="_cell">
                            <div class="notifications-category" data-rubrics-item data-rubrics-id="${item.Value}">
                                <div class="notifications-category__icon">
                                    <svg>
                                        <use xlink:href="#rubrics-${number}-${i}"></use>
                                    </svg>
                                </div>
                                <div class="notifications-category__text">${item.Text}</div>
                                <div class="notifications-category__count">${item.Cnt}</div>
                            </div>
                        </div>
                    `;
                    result += element;
                    count += item.Cnt;
                });
                let rubricsALl = `
                    <div class="_cell">
                        <div class="notifications-category is-active" data-rubrics-all data-rubrics-item data-rubrics-id="0">
                            <div class="notifications-category__icon">
                                <svg>
                                    <use xlink:href="#bell"></use>
                                </svg>
                            </div>
                            <div class="notifications-category__text">${window.translates.notifications.rubricsAll}</div>
                            <div class="notifications-category__count">${count}</div>
                        </div>
                    </div>
                    <div class="_cell _cell--12">
                        <div class="line line--gray"></div>
                    </div>
                `;
                result = rubricsALl + result;
                $rubrics.html(result);
                if (notificationsIsLoaded) {
                    $body.removeClass('is-loading');
                }
            }
        });
    }

    function getNotificationSettings() {
        $settingsTable.addClass('is-loading');

        $.ajax({
            url: '/' + window.currentLang + '/UserMessages/GetUserNotificationSettings',
            type: 'get',
            success: (response) => {
                let result = "";
                $.each(response, function (i, elem) {
                    let item = `
                        <div class="settings-table__row" data-settings-item='${JSON.stringify(elem)}'>
                            <div class="_grid _spacer _spacer--xxs">
                                <div class="_cell _cell--4 _sm:cell--5">
                                    <div class="settings-table__text _text-left">${elem.DirectoryNotificationsName}</div>
                                </div>
                                <div class="_cell _cell--3 _sm:cell--2">
                                    <div class="_flex _justify-center">
                                        <div class="checkbox">
                                            <input type="checkbox" ${elem.SendSms ? 'checked' : ''} ${elem.DisabledCheckbox ? 'disabled' : ''} class="checkbox__control"
                                                   name="userSettings[]" id="userSettings-${i}-1" data-settings-check 
                                                   data-initial-status="${elem.SendSms}" data-type="SendSms">
                                            <label class="checkbox__label" for="userSettings-${i}-1">
                                                <span class="checkbox__checkmark">
                                                    <svg>
                                                        <use xlink:href="#checkmark"></use>
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="_cell _cell--3">
                                    <div class="_flex _justify-center">
                                        <div class="checkbox">
                                            <input type="checkbox" ${elem.PersonalCabinet ? 'checked' : ''} ${elem.DisabledCheckbox ? 'disabled' : ''} class="checkbox__control"
                                                   name="userSettings[]" id="userSettings-${i}-2" data-settings-check 
                                                   data-initial-status="${elem.PersonalCabinet}" data-type="PersonalCabinet">
                                            <label class="checkbox__label" for="userSettings-${i}-2">
                                                <span class="checkbox__checkmark">
                                                    <svg>
                                                        <use xlink:href="#checkmark"></use>
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="_cell _cell--2">
                                    <div class="_flex _justify-center">
                                        <div class="checkbox">
                                            <input type="checkbox" ${elem.Email ? 'checked' : ''} class="checkbox__control" 
                                                   name="userSettings[]" id="userSettings-${i}-3" data-settings-check 
                                                   data-initial-status="${elem.Email}" data-type="Email">
                                            <label class="checkbox__label" for="userSettings-${i}-3">
                                                <span class="checkbox__checkmark">
                                                    <svg>
                                                        <use xlink:href="#checkmark"></use>
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                    result += item;
                });
                $settingsList.html(result);
                $settingsTable.removeClass('is-loading');
            }
        });
    }

    function setNotificationSettings(data) {
        $settingsTable.addClass('is-loading');

        $.ajax({
            url: '/' + window.currentLang + '/UserMessages/SetNotificationSettings',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: (response) => {
                if (response.status) {
                    $settingsTable.removeClass('is-loading');
                    $.magnificPopup.close();
                    window.location.reload();
                } else {
                    console.warn(response.message);
                }
            }
        });
    }

    function toggleFilterBlocks() {
        if (selectedNotifications.length) {
            $filterBlocks.eq(0).addClass('_hide');
            $filterBlocks.eq(1).removeClass('_hide');
        } else {
            $filterBlocks.eq(0).removeClass('_hide');
            $filterBlocks.eq(1).addClass('_hide');
        }
    }

    function clearSelectedNotifications() {
        const $checkboxes = $('[data-notifications-checkbox]').not($checkAll);
        checkNotifications($checkboxes, false);
    }

    function checkNotifications($checkboxes, status = true) {
        selectedNotifications = [];

        $.each($checkboxes, function (i, elem) {
            const $elem = $(elem);

            if (status) {
                $elem.prop('checked', true);
                selectedNotifications.push({id: $elem.closest('.notifications-item').data('notification-id')});
            } else {
                $elem.prop('checked', false);
            }
        })
    }

    function toggleCheckAll() {
        if (elementsOnPage) {
            if ($checkAll.length && selectedNotifications.length === elementsOnPage) {
                $checkAll.prop('checked', true);
            } else {
                $checkAll.prop('checked', false);
            }
        }
    }

    function toggleCheckmark() {
        if (selectedNotifications.length > 0 && selectedNotifications.length < elementsOnPage) {
            $checkmark.addClass('is-partial');
        } else {
            $checkmark.removeClass('is-partial');
        }
    }

    function removeNotifications() {
        let url = "";
        let data = {};

        if (selectedNotifications.length === 1 || notificationToRemove) {
            url = "UserMessages/PostDeleteMessage";
        } else {
            url = "UserMessages/PostDeleteMessageList";
        }

        if (notificationToRemove) {
            data = {id: notificationToRemove};
        } else if (selectedNotifications.length === 1) {
            data = {id: selectedNotifications[0].id};
        } else if (selectedNotifications.length > 1) {
            data = {messageList: selectedNotifications};
        }

        $body.addClass('is-loading');
        $.ajax({
            url: '/' + window.currentLang + '/' + url,
            type: 'post',
            data: data,
            success: (response) => {
                if (response.status) {
                    getNotifications();
                    notificationToRemove = null;
                } else {
                    console.warn(response.message);
                }
                $body.removeClass('is-loading');
            }
        });
    }

    function readNotifications() {
        let url = "";
        let data = {};

        if (selectedNotifications.length === 1) {
            url = "UserMessages/PostReadMessage";
        } else {
            url = "UserMessages/PostReadMessageList";
        }

        if (selectedNotifications.length === 1) {
            data = {id: selectedNotifications[0].id};
        } else if (selectedNotifications.length > 1) {
            data = {messageList: selectedNotifications};
        }

        $body.addClass('is-loading');
        $.ajax({
            url: '/' + window.currentLang + '/' + url,
            type: 'post',
            data: data,
            success: (response) => {
                if (response.status) {
                    const $items = $('[data-notifications-checkbox]:is(:checked)').not($checkAll);
                    $.each($items, function (i, elem) {
                        $(elem).closest('.notifications-item').attr('data-notification-status', 1);
                    })
                } else {
                    console.warn(response.message);
                }
                $body.removeClass('is-loading');
            }
        });
    }

    function toggleSettingsConfirm() {
        const $checkboxes = $('input[data-is-changed]');
        const $button = $('[data-settings-confirm]');

        if ($checkboxes.length) {
            $button.prop('disabled', false);
        } else {
            $button.prop('disabled', true);
        }
    }
}

export default function (elements) {
    init(elements);
}

export function clearSettings() {
    const $items = $('[data-settings-item]');

    $.each($items, function (i, item) {
        const $item = $(item);
        const $checkboxes = $item.find('[data-settings-check]');
        const data = $item.data('settings-item');

        $.each($checkboxes, function (i, check) {
            const $check = $(check);
            const initialStatus = $check.data('initial-status');
            const type = $check.data('type');

            $check.prop('checked', initialStatus);
            $check.removeAttr('data-is-changed');
            data[type] = initialStatus;
        })

        $item.attr('data-settings-item', JSON.stringify(data));
    });

    $('[data-settings-confirm]').prop('disabled', true);
}